export const ButtonStyle1 = 'my-2 px-4 py-2 text-xs md:text-base rounded-md bg-stone-700 text-stone-400 transition-colors duration-300 ease-in-out hover:bg-stone-600 hover:text-stone-100 shadow-md hover:shadow-lg';
export const ButtonStyle2 = 'text-stone-800 hover:text-stone-950';
export const ButtonStyleAdd = 'bg-stone-800 text-stone-50 px-6 py-2 rounded-md hover:bg-stone-950 transition-colors duration-300 ease-in-out ';
export const ModalTextStyle = 'text-xl font-bold text-stone-500 my-4'
export const ListItemStyle = 'w-max md:w-max my-2 px-4 py-2 text-xs md:text-base rounded-md bg-stone-700 text-stone-400 hover:bg-stone-600 hover:text-stone-100';
export const ButtonStyleDelete = 'my-2 px-4 py-2 text-stone-800 hover:text-stone-950 bg-red-600 hover:bg-red-800 rounded-md';
export const InputContainerStyle = 'flex flex-col gap-1 my-4';
export const InputFieldStyle = 'px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-stone-500 transition duration-300 text-stone-700 placeholder-stone-400';
export const InputLabelStyle = 'text-sm md:text-base text-stone-600 font-medium';
export const TextareaFieldStyle = 'px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-stone-500 transition duration-300 text-stone-700 placeholder-stone-400 resize-none';

export const MenuSelect = {
    Add_New: 'new',
    View_Current: 'viewCurrent',
    View_Past: 'viewPast',
    View_Stat: 'viewStat',
    View_Chat: 'viewChat'
  };

  export const loginStyles = {
    container: { textAlign: "center", marginTop: "100px" },
    input: { display: "block", margin: "10px auto", padding: "10px", width: "80%", maxWidth: "300px" },
    button: { padding: "10px 20px", backgroundColor: "blue", color: "white", border: "none", cursor: "pointer" },
    error: { color: "red" }
  };

  export const URL = process.env.REACT_APP_BASE_URL
  